<template>
  <div
    v-if="showBackground"
    class="jwl-icon"
    :class="rootClasses">
    <JwlIcon
      class="jwl-icon__icon"
      :icon-name="taskIconName"
      :icon-style="taskIconStyle" />
  </div>
  <JwlIcon
    v-else
    class="jwl-icon"
    :class="rootClasses"
    :icon-name="taskIconName"
    :icon-style="taskIconStyle" />
</template>

<script setup>
  const props = defineProps({
    taskType: String,
    useDuotone: Boolean,
    marginRight: Boolean,
    showBackground: Boolean,
  });

  const rootClasses = computed(() => ({
    'jwl-icon--margin-right': props.marginRight,
    'jwl-icon--show-background': props.showBackground,
  }));

  const taskIconName = computed(() => {
    let taskIcon;
    switch (props.taskType) {
      case 'submit_text':
        taskIcon = 'file-alt';
        break;
      case 'submit_work':
        taskIcon = 'arrow-to-top';
        break;
      case 'discuss':
        taskIcon = 'comments';
        break;
      case 'track':
        taskIcon = 'male';
        break;
      case 'attendance':
        taskIcon = 'handshake';
        break;
      case 'quiz':
        taskIcon = 'quiz';
        break;
      case 'final_examination':
        taskIcon = 'final-exam';
        break;
      case 'survey':
        taskIcon = 'chart-bar';
        break;
      default:
        taskIcon = 'exclamation-triangle';
    }

    return taskIcon;
  });

  const taskIconStyle = computed(() => {
    let { useDuotone } = props;

    if (['chart-bar', 'exclamation-triangle'].includes(taskIconName.value)) {
      useDuotone = false;
    }

    return useDuotone
      ? 'duotone'
      : 'regular';
  });
</script>

<style lang="scss">
@use "@base/styles/mixins";

.jwl-icon {
  $root: &;

  &--show-background {
    align-items: center;
    background: var(--concentration-color, currentColor);
    border-radius: 50%;
    display: flex;
    flex: 0 0 2.5rem;
    font-size: 1rem;
    height: 2.5rem;
    justify-content: center;
    width: 2.5rem;

    #{$root}__icon {
      color: var(--color-white);
    }
  }

  &--margin-right {
    @include mixins.ltrtl(margin-right, margin-left, .75rem);
  }
}
</style>
